export const MEDIA_QUERY_MD = "@media screen and (min-width: 768px)";
export const MEDIA_QUERY_SM = "@media screen and (max-width: 568px)";
